import { useMemo } from 'react'
import { Icon, type TIconProps } from '~/components/icon'
import { useInputTextContext } from '../../input-text'
import type {
  InputTextIconProps,
  InputTextScopedProps,
} from '../../input-text.types'

export function InputTextIcon({
  __scopeInputText,
  color = 'colorTextNeutralDefault',
  ...props
}: InputTextScopedProps<InputTextIconProps>) {
  const { size, disabled, readOnly } = useInputTextContext(
    'InputTextField',
    __scopeInputText
  )

  const iconSize = useMemo(() => {
    const inputTextIconSizeMapper: Record<string, TIconProps['size']> = {
      md: 'extra-small',
      ml: 'small',
      lg: 'small',
      xl: 'small',
    }
    return inputTextIconSizeMapper?.[size!]
  }, [size])

  const iconColorMapping = (): TIconProps['color'] => {
    return disabled
      ? 'colorTextNeutralDisabled'
      : readOnly
        ? 'colorTextNeutralReadonly'
        : 'colorTextNeutralDefault'
  }

  return (
    <div className="flex items-center">
      <Icon {...props} color={iconColorMapping()} size={iconSize} />
    </div>
  )
}
